export function selectDocument(state, id) {
  return state.document.documents[id];
}
